import Settings from "../domain/Settings";
import {getSlotsAndPositions} from "../services/slotManager";
import cmd from "../utils/cmd";

declare global {
	interface Window {
		ootag?: {
			queue?: Array<() => void>
			initializeOo?: (cfg: OptOutInitConfig) => void
			defineSlot?: (cfg: { adSlot: string, targetId: string }) => void
		};
	}
}

interface OptOutInitConfig {
	publisher: number;
	onlyNoConsent?: 0 | 1;
	consentTimeOutMS?: number;
}

export function init(): void {
	const settings = Settings.getInstance();

	if (!settings.features?.optOut)
		return;

	if (!settings.optOut?.publisher) {
		console.warn('[ADVERT] OptOut module is loaded but is missing configuration. Disabling.');
		return;
	}

	window.ootag = window.ootag || {};
	window.ootag.queue = window.ootag.queue || [];

	window.ootag.queue.push(() => {
		window.ootag.initializeOo({
			publisher: settings.optOut.publisher,
			onlyNoConsent: 1,
			consentTimeOutMS: 500
		});
	});

	window.advert.loadSlot = loadOptOutTag;

	cmd.accept('loaded');
}

async function loadOptOutTag(platformName: string, nodeId?: string | HTMLElement) {
	(await getSlotsAndPositions(platformName, nodeId)).forEach((slot) => {
		window.ootag.queue.push(() => {
			window.ootag.defineSlot({
				adSlot: slot.name,
				targetId: slot.domId
			});
		});
	});
}
